/**
 * Server-rendered JSON-LD for entity hubs (clubs, competitions, players,
 * markets, countries, guides, landings). Emitted from route head().scripts so
 * crawlers see it in the first HTML.
 */
import { breadcrumbJsonLd } from "@/lib/seoSchema";

const SITE = "https://statlign.com";

type Crumb = { name: string; path: string };
type Script = { type: string; children: string };

export function entityScripts(opts: {
  type: string;
  name: string;
  path: string;
  description?: string;
  crumbs: Crumb[];
  extra?: Record<string, unknown>;
}): Script[] {
  const url = `${SITE}${opts.path}`;
  const entity = {
    "@context": "https://schema.org",
    "@type": opts.type,
    "@id": `${url}#entity`,
    name: opts.name,
    url,
    ...(opts.description ? { description: opts.description } : {}),
    ...opts.extra,
  };
  const page = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${url}#webpage`,
    url,
    name: opts.name,
    inLanguage: "en",
    isPartOf: { "@id": `${SITE}/#website` },
    publisher: { "@id": `${SITE}/#organization` },
    about: { "@id": `${url}#entity` },
    breadcrumb: { "@id": `${url}#breadcrumb` },
  };
  const crumbs = { ...breadcrumbJsonLd([{ name: "Home", path: "/" }, ...opts.crumbs]), "@id": `${url}#breadcrumb` };
  return [entity, page, crumbs].map((g) => ({ type: "application/ld+json", children: JSON.stringify(g) }));
}
